import { z } from '@/libs/zod';

import { customerContactSchema } from './Customer';

import { LuckySequencyType } from '../enums';

export const raffleSchema = z.object({
  id: z.string(),
  tag: z.string(),
  numbering: z.number(),
  name: z.string(),
  drawDate: z.string(),
  lastPurchase: z.string(),
  maxTicketsPerCpf: z.number().nullable(),
  ticketPrice: z.number(),
  urlBanner: z.string(),
  ticketsBought: z.number(),
  promotionDescription: z.string().nullable(),
  promotionPercentage: z.number(),
  promotionTicketsAmount: z.number(),
  isPromotionAvailable: z.boolean(),
  urlThumbnail: z.string(),
  model: z.object({
    free: z.boolean(),
  }),
  status: z.string(),
  urlFacebook: z.string().nullable(),
  urlWhatsapp: z.string().nullable(),
  urlTelegram: z.string().nullable(),
  redirectRaffleUrl: z.string().nullable(),
  protocolNumber: z.string(),
  prizeValue: z.number(),
});

export const availablePrizesSchema = z.object({
  prizeValue: z.number(),
  name: z.string(),
  type: LuckySequencyType,
});

export const rafflePurchasedSchema = z.object({
  id: z.string(),
  name: z.string(),
  numbering: z.number(),
  status: z.string(),
  drawStatus: z.string(),
  drawDate: z.string(),
  ticketsBought: z.number(),
  lastPurchase: z.string(),
  urlThumbnail: z.string(),
  urlScratcherBanner: z.string(),
  urlWhatsapp: z.string(),
  urlFacebook: z.string(),
  redirectRaffleUrl: z.string(),
  user: customerContactSchema,
  availablePrizes: z.array(availablePrizesSchema),
});

export const rafflesPurchasedResponseSchema = z.object({
  data: z.array(raffleSchema),
  totalCount: z.number(),
  user: customerContactSchema,
});

export type Raffle = z.infer<typeof raffleSchema>;
export type RafflePurchased = z.infer<typeof rafflePurchasedSchema>;
export type RafflesPurchasedResponse = z.infer<typeof rafflesPurchasedResponseSchema>;
